import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {  Router } from '@angular/router';

@Component({
    selector: 'lib-hybrid-cloud-registration-alert',
    templateUrl: './hybrid-cloud-registration-alert.component.html',
    styleUrls: ['./hybrid-cloud-registration-alert.component.scss'],
    standalone: false
})
export class HybridCloudRegistrationAlertComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<HybridCloudRegistrationAlertComponent>,
        private router: Router
    ) {
    }

    navigateToLink() {
        this.router.navigate([this.data.routerLink]);
        this.close();
    }

    close() {
        this.dialogRef.close();
    }
}
